export const ProjectData=[
    {
        id:1,
        title:"LOTTE Finance Vietnam (Mar 2024 - Present)",
        about: "Leading frontend architecture for digital finance platform. Architected enterprise-grade monorepo from scratch using Yarn 3 workspaces, achieving 80% code sharing with 99% shared business logic between mobile and web platforms. Maintaining native iOS and Android implementations for 4 production apps with comprehensive security measures including SSL pinning, jailbreak/root detection, and anti-tampering protection.",
        tags:["React Native", "Next.js", "TypeScript", "Yarn Workspaces", "Monorepo", "iOS Native", "Android Native", "Security"],
        demo:"https://www.lottefinance.vn",
        github:"https://github.com/nguyenduythuc",
        image:"/images/company-logos/lottefinance.jpg",
    },
    {
        id:2,
        title:"SubWallet Mobile (Feb 2023 - Mar 2024)",
        about: "Led mobile development for a multi-chain crypto wallet supporting 200+ blockchain networks with 500K+ active users. Architected and developed SubWallet Mobile app from scratch using React Native and TypeScript, achieving 4.7+ rating on App Store/Play Store. Designed custom React Native UI library with Storybook and Reanimated 3, reducing development time by 40%.",
        tags:["React Native", "TypeScript", "Redux", "Reanimated 3", "Storybook", "Web Assembly", "Web3", "Blockchain"],
        demo:"https://www.subwallet.app",
        github:"https://github.com/Koniverse/SubWallet-mobile",
        image:"/images/company-logos/subwallet.jpg",
    },
    {
        id:3,
        title:"VNDirect web, mobile app (Nov 2019 - Jan 2023)",
        about: "At VNDirect, i am a front-end technical leader. I created & build these project from the beginning, these app is about ecommerce, real estate and erp for careby customer's account",
        tags:["ReactJS", "React Native", "Redux", "NextJs", "AntDesign", "Javascript", "Firebase", "Fastlane"],
        demo:"https://propfit.vn",
        github:"https://github.com/nguyenduythuc",
        image:"/images/company-logos/vndirect.png",
    },
    {
        id:4,
        title:"Homedy mobile app (Mar 2019 - Nov 2019)",
        about: "In this time in Homedy, i focused mobile app only. I created the main app from the beginning, leader of 2 and build scrum team for the company",
        tags:["ReactJS", "React Native", "Redux", "Realm", "SignalR", "Javascript", "S3 - AWS", "OneSignal"],
        demo:"https://apps.apple.com/vn/app/b%E1%BA%A5t-%C4%91%E1%BB%99ng-s%E1%BA%A3n-homedy/id1438315559?l=vi",
        github:"https://github.com/nguyenduythuc",
        image:"/images/company-logos/homedy.svg",
    },
    {
        id: 5,
        title:"OnOnPay web, mobile app (Mar 2015 - Mar 2019)",
        about: "I created several web app & mobile app for payment, topup, agent management,vendor management, cash in - cash out management. In websites, i used jquery, laravel, nodejs. On mobile, i used Android native for first 2 years, and then i use react native till now.",
        tags:["Jquery", "Laravel", "Javascript", "Firebase", "Html/Css", "Java", "Android SDK", "React", "React Native"],
        demo:"https://ononpay.com",
        github:"https://github.com/nguyenduythuc",
        image:"/images/company-logos/ononpay.jpg",
    },
];

